export const domainPathname =
	process.env.REACT_APP_MODE === "production" ? window.location.origin : process.env.PUBLIC_URL

export const normalizeBoolean = (value: string) => {
	if (value === "true") return true
	if (value === "false" || undefined || "undefined") return false
	return Boolean(value)
}

export function convertToBoolean(value) {
	if (typeof value === "boolean") {
		return value
	} else if (typeof value === "string") {
		return value.toLowerCase() === "true"
	}
	return false
}

export function booleanToString(value) {
	if (value === "true" || value === true) {
		return "true"
	}
	return "false"
}

export const sortByProperty = (property: string) => {
	return function (a, b) {
		if (a[property] > b[property]) return 1
		else if (a[property] < b[property]) return -1

		return 0
	}
}

export const getProtectedEmail = (mail: string) => {
	const splittedEmail = mail.split("@")
	const addX = new Array(splittedEmail[0].slice(2).length + 1).join("*")

	return splittedEmail[0].slice(0, 2) + addX + "@" + splittedEmail[1]
}

export const openInNewTab = (url: string, { focus = false }) => {
	const newWindow = window.open(url, "_blank", "noopener,noreferrer")
	if (newWindow) newWindow.opener = null
	if (focus && newWindow !== null) newWindow.focus()
}

export function replaceUrlParams(
	urlTemplate: string,
	params: { [key: string]: string | number }
): string {
	return Object.keys(params).reduce((url, key) => {
		const value = encodeURIComponent(String(params[key]))
		return url.replace(new RegExp(`:${key}`, "g"), value)
	}, urlTemplate)
}

export const deepEqual = (obj1, obj2) => {
	if (obj1 === obj2) {
		return true
	}

	if (typeof obj1 !== "object" || typeof obj2 !== "object" || obj1 == null || obj2 == null) {
		return false
	}

	const keys1 = Object.keys(obj1)
	const keys2 = Object.keys(obj2)

	if (keys1.length !== keys2.length) {
		return false
	}

	for (let key of keys1) {
		if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
			return false
		}
	}

	return true
}

export const shallowEqual = (obj1: object, obj2: object) => {
	if (obj1 === obj2) {
		return true
	}

	if (typeof obj1 !== "object" || typeof obj2 !== "object" || obj1 == null || obj2 == null) {
		return false
	}

	const keys1 = Object.keys(obj1)
	const keys2 = Object.keys(obj2)

	if (keys1.length !== keys2.length) {
		return false
	}

	for (const key of keys1) {
		if (!keys2.includes(key) || obj1[key] !== obj2[key]) {
			return false
		}
	}

	return true
}
